import axios from 'axios';
import { getToken } from '@/services/auth.service';
import router from '@/router';
import store from '@/store';
import { getRuntimeConfig } from '@/utils/env';
import app from '../../main';

const http = axios.create({
  headers: {
    'Content-Type': 'application/json',
  },
});

const tokenString = window.localStorage.getItem('_user');

if (tokenString !== null) {
  const token = JSON.parse(tokenString);
  http.defaults.headers.common.Authorization = `Bearer ${token.access_token}`;
}

http.interceptors.request.use(async (config) => {
  const runtimeConfig = await getRuntimeConfig();
  // eslint-disable-next-line no-param-reassign
  config.baseURL = runtimeConfig.baseApiUrl;
  app.$Progress.start();
  return config;
});

/**
 * Refreshing for multiple paralled request
 * @type {Boolean}
 */
let isRefreshing = false;
let failedQueue = [];

/**
 * Add request to queue for processing
 */
const processQueue = (error, token = null) => {
  failedQueue.forEach((prom) => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });

  failedQueue = [];
};

http.interceptors.response.use((response) => {
  app.$Progress.finish();
  return response;
}, async (error) => {
  app.$Progress.fail();
  const originalRequest = error.config;

  if (error.response && error.response.status === 401 && !originalRequest.retry) {
    if (error.config.url === '/oauth/token') {
      return store.dispatch('LOGOUT').then(() => {
        router.push({ name: 'login' });
        return Promise.reject(error);
      });
    }

    if (isRefreshing) {
      return new Promise((resolve, reject) => {
        failedQueue.push({ resolve, reject });
      }).then((token) => {
        originalRequest.headers.Authorization = `Bearer ${token}`;
        return http(originalRequest);
      }).catch((err) => Promise.reject(err));
    }

    originalRequest.retry = true;
    isRefreshing = true;

    const token = getToken();

    const config = {
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: '',
      },
    };

    const runtimeConfig = await getRuntimeConfig();
    const bodyFormData = new FormData();

    bodyFormData.set('grant_type', 'refresh_token');
    bodyFormData.set('refresh_token', token.refresh_token);
    bodyFormData.set('client_id', runtimeConfig.authClientId);
    bodyFormData.set('client_secret', runtimeConfig.authClientSecret);

    return new Promise((resolve, reject) => {
       http.post('/oauth/token', bodyFormData, config)
        .then(({ data }) => {
            window.localStorage.setItem('_user', JSON.stringify(data));
            http.defaults.headers.common.Authorization = `Bearer ${data.access_token}`;
            originalRequest.headers.Authorization = `Bearer ${data.access_token}`;
            processQueue(null, data.access_token);
            resolve(http(originalRequest));
        })
        .catch((err) => {
            processQueue(err, null);
            reject(err);
        })
        .then(() => {
          isRefreshing = false;
        });
    });
  }

  return Promise.reject(error);
});

export default http;
